import { useRouter } from "next/router";

export default function useShowReleaseCodes(enableReleaseCodes: boolean) {
  const router = useRouter();
  const isUnlistedRelease = router.query.slug ? true : false;

  return !isUnlistedRelease && enableReleaseCodes;
}
